// Preview URLs are temporary capabilities, never the canonical references saved in posts.
const backend = process.env.REACT_APP_BACKEND_URL || "";
let identity;
const previews = new Map();

export const mediaIdentity = () => localStorage.getItem("token") || "";
export const deliveryUrl = (value) => value?.startsWith("/api/") ? `${backend}${value}` : value;

export function mediaPath(value) {
  try {
    const parsed = new URL(value, window.location.origin);
    if (!parsed.pathname.startsWith("/api/files/")) return null;
    return decodeURIComponent(parsed.pathname.slice("/api/files/".length));
  } catch { return null; }
}

function currentCache() {
  const current = mediaIdentity();
  if (identity !== current) { previews.clear(); identity = current; }
  return previews;
}

export function cacheMediaResponse(data, requestedBy = mediaIdentity()) {
  if (requestedBy !== mediaIdentity()) return;
  const cache = currentCache();
  for (const item of Array.isArray(data) ? data : [data]) {
    const path = item?.storage_path || item?.path;
    if (path && item.preview_url && item.preview_expires_at) {
      cache.set(path, { url: deliveryUrl(item.preview_url), expires: item.preview_expires_at });
    }
  }
}

export function cachedMedia(value) {
  const path = mediaPath(value);
  if (!path) return null;
  const cached = currentCache().get(path);
  return cached && cached.expires * 1000 > Date.now() + 30000 ? cached : null;
}
